import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { MarketingLayout, Section } from "@/components/marketing/MarketingLayout";
import api from "@/lib/api";
import { inrFull } from "@/lib/constants";
import { Button } from "@/components/ui/button";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  const [seg, setSeg] = useState("B2C");
  const nav = useNavigate();
  useEffect(() => { api.get("/plans").then(({ data }) => setPlans(data)); }, []);
  const shown = plans.filter((p) => p.segment === seg);

  return (
    <MarketingLayout>
      <section className="bg-sp-navy text-white">
        <div className="sp-container py-20 text-center">
          <div className="sp-eyebrow mb-3">Pricing</div>
          <h1 className="text-4xl lg:text-5xl font-bold tracking-tight">Simple, transparent pricing.</h1>
          <p className="mt-4 text-white/65">Choose the plan that fits your journey.</p>
          <div className="mt-8 inline-flex rounded-full border border-white/15 p-1">
            {["B2C", "B2B"].map((s) => (
              <button key={s} data-testid={`pricing-seg-${s}`} onClick={() => setSeg(s)}
                className={`px-6 py-2 rounded-full text-sm transition-colors ${seg === s ? "bg-sp-orange text-white" : "text-white/70"}`}>
                {s === "B2C" ? "For Homeowners" : "For Businesses"}
              </button>
            ))}
          </div>
        </div>
      </section>

      <Section>
        <div className="grid md:grid-cols-3 gap-6">
          {shown.map((p, i) => (
            <div key={p.id} data-testid={`plan-${p.id}`}
              className={`rounded-xl border p-7 bg-white flex flex-col ${i === 1 ? "border-sp-orange shadow-lg shadow-sp-orange/10" : "border-slate-200"}`}>
              {i === 1 && <div className="text-[11px] font-semibold text-sp-orange uppercase tracking-wider mb-2">Most Popular</div>}
              <div className="font-semibold text-lg text-sp-navy">{p.name}</div>
              <div className="mt-3 flex items-end gap-1">
                <span className="text-4xl font-bold text-sp-navy">{p.monthly === 0 ? (p.id === "enterprise" ? "Custom" : "₹0") : inrFull(p.monthly)}</span>
                {p.monthly > 0 && <span className="text-sm text-slate-400 mb-1">/mo</span>}
              </div>
              <div className="text-xs text-slate-400 mt-1">{p.users} users · {p.projects} projects · {p.storage_gb}GB</div>
              <ul className="mt-6 space-y-2.5 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-slate-600"><Check className="h-4 w-4 text-sp-orange mt-0.5 shrink-0" />{f}</li>
                ))}
              </ul>
              <Button data-testid={`plan-cta-${p.id}`} onClick={() => nav("/register")}
                className={`mt-7 rounded-full h-11 ${i === 1 ? "bg-sp-orange hover:bg-sp-orangedark" : "bg-sp-navy hover:bg-sp-charcoal"}`}>
                {p.id === "enterprise" ? "Contact Sales" : "Get Started"}
              </Button>
            </div>
          ))}
        </div>
      </Section>
    </MarketingLayout>
  );
}
